import { ReactNode } from 'react'
import { Tooltip } from 'antd'

interface IInfoFieldProps {
  label: string
  value: ReactNode
  showTooltip?: boolean
  className?: string
}

export const InfoField = ({ label, value, showTooltip = false, className }: IInfoFieldProps) => (
  <div className={className}>
    <p className={'text-[14px] text-aqua'}>{label}</p>
    {value ? (
      <Tooltip title={showTooltip && value}>
        <p className={'max-w-fit truncate font-medium'}>{value}</p>
      </Tooltip>
    ) : (
      <p>–</p>
    )}
  </div>
)
